import axios from '@/libs/api.request';

export const getRequestLogList = data => {
    return axios.request({
        url: '/api/requestLog/getRequestLogList',
        data: data,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
export const getHourlyStatistics = data => {
    return axios.request({
        url: '/api/requestLog/getHourlyStatistics',
        data: data,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
export const getDailyStatistics = data => {
    return axios.request({
        url: '/api/requestLog/getDailyStatistics',
        data: data,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
export const getMonthlyStatistics = data => {
    return axios.request({
        url: '/api/requestLog/getMonthlyStatistics',
        data: data,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};